import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { ClaimsTypes } from "@bbwt/modules/security/claims-types";
import { IQueryCommand, StringFilter, StringFilterMatchMode } from "@features/filter";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import { UserHelperService } from "@main/users/user-helper.service";
import { genericSearchValues } from "@mipro/classes/search-utlis";
import { SystemCodeType } from "@project/governingbody/system-code-type";
import { Diagnosis } from "./diagnosis";
import { OsiicsFields } from "./osiics-fields";
import { DiagnosisSearchResult } from "./diagnosisSearchResult";

@Injectable({
    providedIn: "root"
})
export class DiagnosisService extends BaseDataService {
    public readonly url = "api/diagnosis";
    public readonly entityTitle = "Diagnosis";

    constructor(
        http: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory,
        private userHelperService: UserHelperService,
        private appOnlineService: AppOnlineStateService
    ) {
        super(http, handlersFactory);
    }

    forLaterRemove() {
        return Promise.resolve(<Diagnosis[]>[]);
    }

    getOSIICSFields() {
        return this.handleRequest(this.http.get<OsiicsFields>(`${this.url}/osiics/fields`), this.handlersFactory.getDefault());
    }

    getOSIICSBodyParts() {
        return this.handleRequest(this.http.get<string[]>(`${this.url}/osiics/body-parts`), this.handlersFactory.getDefault());
    }

    searchDiagnoses(term: string) {
        if (!this.appOnlineService.isAppOnline) {
            return this.searchDiagnosesOffline(term);
        }

        const queryCommand = <IQueryCommand>{
            filters: [new StringFilter("searchTerm", term, StringFilterMatchMode.Contains)]
        };
        const params = this.constructHttpParams(queryCommand);

        return this.handleRequest(this.http.get<DiagnosisSearchResult>(`${this.url}/search`, { params }));
    }

    private async searchDiagnosesOffline(term: string) {
        const orgSystemCode = +this.userHelperService.findFirstValue(ClaimsTypes.OrganisationSystemCode);
        if (orgSystemCode === SystemCodeType.SNOMED) {
            return  { results: [], nhsTerminologyServerHealthy: false } as DiagnosisSearchResult
        }

        const osiicsFields = await this.getOSIICSFields();
        return { results: genericSearchValues(osiicsFields.osiicsCodes, term, osiics => osiics.name),
                 nhsTerminologyServerHealthy: false } as DiagnosisSearchResult   
    }
}
